import dark from "./dark";
import light from "./default";

const themes = {
  light,
  dark
};

export default themes;
